import Vue from "vue";
import Vuex from "vuex";
import auth from './auth';
import invoice from './invoice';
import request from './request';
import visit from './visit';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    users: [],
    mobsUser: false,
    status_filters: [],
    visits_status_filters: [],
    visits_type_filters: [],
    request_status_filters: [],
    assigned_user: null,
    search: null,
    request_status: null,
    visit_type: null,
    visit_status: null,
    notification_type: null,
    notification_status: null,
    do_send_request: false,
    app_display_scheme: null,
    app_display_username: null,
    app_requires_images_to_finish: null,
    user_techReqs: [],
    current_visit: {},
    current_techReq: {},
    current_budget: {},
    current_charge: {},
    loading_requests: true,
    loading_request_detail: false,
    authorised: false,
    last_screen: "",
    app_title: "",
    user_notifications: [],
    notification_types: [],
    unread_notifications: null,
    current_notification: {},
    loading_notifications: false,
    headers: [],
    snackbar: {
      show: false,
      text: ""
    },
    reload_data: false,
    reload_request: false,
    current_headers_version: null,
    updateHeaders: null,
    updateCachedTechReq: null,
    connected: false,
    refresh_notifications: false,
    message_chat: null
  },
  mutations: {
    setMobsUser(state, value) {
      state.mobsUser = value
    },
    refresh_notifications(state, value) {
      state.refresh_notifications = value;
    },
    connected(state, value) {
      state.connected = value;
    },
    load_users(state, value) {
      state.users = value;
    },
    set_status_filters(state, value) {
      state.status_filters = value;
    },
    set_visits_status_filters(state, value) {
      state.visits_status_filters = value;
    },
    set_visits_type_filters(state, value) {
      state.visits_type_filters = value;
    },
    set_request_status_filters(state, value) {
      state.request_status_filters = value;
    },
    perform_send_request(state, value) {
      state.do_send_request = value;
    },
    perform_search(state, term) {
      state.search = term;
    },
    reset_search(state) {
      state.search = null;
    },
    filter_requests_by_status(state, value) {
      state.request_status = value;
    },
    filter_visits_by_type(state, value) {
      state.visit_type = value;
    },
    filter_visits_by_status(state, value) {
      state.visit_status = value
    },
    filter_notifications_by_type(state, value) {
      state.notification_type = value;
    },
    filter_notifications_by_status(state, value) {
      state.notification_status = value;
    },
    filter_items_by_user(state, user) {
      state.assigned_user = user;
    },
    set_user_settings(state, value) {
      if (value == null) return;
      state.app_display_scheme = value.app_display_scheme;
      state.app_display_username = value.app_display_username;
      state.app_requires_images_to_finish = value.app_requires_images_to_finish;
    },
    set_user_techReqs(state, value) {
      state.user_techReqs = value;
    },
    set_current_visit(state, value) {
      state.current_visit = value;
    },
    set_current_techReq(state, value) {
      state.current_techReq = value;
    },
    set_current_budget(state, value) {
      state.current_budget = value;
    },
    set_current_charge(state, value) {
      state.current_charge = value;
    },
    set_last_screen(state, value) {
      state.last_screen = value;
    },
    set_app_title(state, value) {
      state.app_title = value;
    },
    set_loading_requests(state, value) {
      state.loading_requests = value;
    },
    set_loading_request_detail(state, value) {
      state.loading_request_detail = value;
    },
    set_user_notifications(state, value) {
      state.user_notifications = value;
    },
    set_notification_types(state, value) {
      state.notification_types = value;
    },
    set_unread_notifications(state, value) {
      state.unread_notifications = value;
    },
    set_loading_notifications(state, value) {
      state.loading_notifications = value;
    },
    set_current_notification(state, value) {
      state.current_notification = value;
    },
    updateCachedTechReq(state, value) {
      state.updateCachedTechReq = value;
    },
    update_techReq(state, newRequest) {
      const oldRequestIndex = state.user_techReqs.findIndex(
        item => item.id === newRequest.id
      );
      state.user_techReqs[ oldRequestIndex ] = newRequest;
    },
    set_authorised(state, value) {
      state.authorised = value;
    },
    set_headers(state, value) {
      state.headers = value;
    },
    show_alert(state, value) {
      state.snackbar.text = value;
      state.snackbar.show = true;
    },
    reload_data(state, value) {
      state.reload_data = value;
    },
    reload_request(state, value) {
      state.reload_request = value;
    },
    set_current_headers_version(state, value) {
      state.current_headers_version = value;
    },
    updateHeaders(state, value) {
      state.updateHeaders = true;
    },

    set_message_chat(state, value) {
      state.message_chat = value;
    }
  },
  actions: {
    setMobsEnviroment({ commit }) {
      if (process.env.VUE_APP_IS_MOBS === 'true') {
        commit('setMobsUser', true)
      }
    },
    setCurrentTechnician({ commit, getters }, requestId) {
      const idAsNumber = Number(requestId);
      const technicianRequests = getters.technicianRequests ?? [];
      const currentTechnician = technicianRequests.find(
        (item) => {
          const request = item.request;
          return request.id === idAsNumber
        }
      );
      commit("set_current_techReq", currentTechnician);
    },
  },
  getters: {
    technicianRequests: state => {
      const requestsFromLocalStorage = localStorage.getItem("technicianInfo");

      return requestsFromLocalStorage
        ? JSON.parse(requestsFromLocalStorage)
        : state.user_techReqs || [];
    }
  },
  modules: {
    auth,
    invoice,
    request,
    visit
  }
});
